import { Component, Input } from '@angular/core';
import { FormArray, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

import {
  CustomFormDetailsFragment, CustomFormFieldObjectTypeTypes, EntityTypeDetailsFragment
} from 'generated/graphql';

import { CustomFormBuilderServiceFactory } from 'app/custom-forms/CustomFormBuilder.service';
import { CustomFormFieldLabelIcons } from 'app/custom-forms/CustomFormLabelIcons';

@Component({
  selector: 'app-custom-form-renderer',
  templateUrl: './custom-form-renderer.component.html',
  styleUrls: ['./custom-form-renderer.component.scss']
})

export class CustomFormRendererComponent  {
  @Input() form: UntypedFormGroup;
  @Input() customForm: CustomFormDetailsFragment;
  @Input() entityType: EntityTypeDetailsFragment;
  @Input() showExistingValues = false;

  /**
   * optional entity type id
   * if provided, this will be used to show existing values
   */
  @Input() targetId: string;


  get campaignId() {
    return this.customForm.campaignId;
  }

  get controlNames() {
    return this.form ? Object.keys(this.form.controls) : [];
  }

  isFormArray(controlName: string): boolean {
    return (this.form.get(controlName) instanceof FormArray) || (this.form.get(controlName) instanceof UntypedFormArray);
  }

  constructor() {
  }

  getLabel(controlName: string) {
    const field = CustomFormBuilderServiceFactory.getFormFieldSettingsFromControlName(controlName, this.customForm);
    return CustomFormFieldLabelIcons.getIconAndLabel(this.entityType, field)?.label;
  }

  getTagCategory(controlName: string) {
    const field = CustomFormBuilderServiceFactory.getFormFieldSettingsFromControlName(controlName, this.customForm);
    return field?.tagCategory;
  }

  getEntityConnectionType(controlName: string) {
    const field = CustomFormBuilderServiceFactory.getFormFieldSettingsFromControlName(controlName, this.customForm);
    return field?.entityConnectionType;
  }

  isTagCategoryInput(controlName: string) {
    return controlName.includes('TagCategory');
  }

  isGlobalNoteInput(controlName: string) {
    return controlName.includes('GlobalNote');
  }

  isConnectionInput(controlName: string) {
    return controlName.includes('Connection');
  }

  isNameInput(controlName: string) {
    const settings = this.getFieldDetails(controlName);

    return (settings.fieldObjectType === CustomFormFieldObjectTypeTypes.Entity)
      && (settings.objectAttribute === 'name');
  };

  isDemographicsInput(controlName: string) {
    const settings = this.getFieldDetails(controlName);
    return (settings.fieldObjectType === CustomFormFieldObjectTypeTypes.Entity) &&
      (settings.objectAttribute === 'demographics');
  }

  // TODO: Looks like we didn't split this up when we split the DOB and Language forms
  isLanguageAttribute(controlName: string) {
     const settings = this.getFieldDetails(controlName);
     return (settings.fieldObjectType === CustomFormFieldObjectTypeTypes.Entity) &&
      (settings.objectAttribute === 'language');
  }

  isMultiselectTagCategory(controlName: string) {
    return this.isTagCategoryInput(controlName) && this.getTagCategory(controlName).multiselectable;
  }

  isSingleSelectTagCategory(controlName: string) {
    return this.isTagCategoryInput(controlName) && this.getTagCategory(controlName).multiselectable === false;
  }

  private getFieldDetails(controlName: string) {
    return CustomFormBuilderServiceFactory.getFormFieldSettingsFromControlName(controlName, this.customForm);
  }

}
